import React from 'react';

/**
 * Inviting empty-state with an optional call-to-action button.
 * Replaces the plain "no data" text across list screens.
 */
export default function EmptyState({
  icon = '📭',
  title,
  actionLabel,
  onAction,
}: {
  icon?: string;
  title: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="empty-state" style={{ textAlign: 'center', padding: '48px 20px' }}>
      <div className="icon" style={{ fontSize: 48, marginBottom: 12 }}>{icon}</div>
      <p style={{ color: '#777', fontSize: 16, marginBottom: actionLabel ? 20 : 0 }}>{title}</p>
      {actionLabel && onAction && (
        <button className="btn btn-primary" onClick={onAction}>+ {actionLabel}</button>
      )}
    </div>
  );
}
